var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayStoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_977",
    "data-name": "Rectangle 977",
    width: 12.438,
    height: 13.992,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App_store",
    "data-name": "App store",
    transform: "translate(-815 -621)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_969",
    "data-name": "Rectangle 969",
    width: 14,
    height: 14,
    transform: "translate(815 621)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3145",
    "data-name": "Group 3145",
    transform: "translate(815.838 621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    d: "M5.96,7.295l.01.01v-.01Z",
    transform: "translate(0.055 0.067)",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3144",
    "data-name": "Group 3144",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3143",
    "data-name": "Group 3143",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    d: "M12.335,7.271a1.234,1.234,0,0,1-.565.747L9.125,9.542,6.34,6.979l2.8-2.6L11.77,5.9a1.248,1.248,0,0,1,.444.444,1.2,1.2,0,0,1,.121.928",
    transform: "translate(0.059 0.04)",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M5.963,7.295l.01.01v-.01Zm-.343.343H5.6v.01h.01l2.6,2.392Z",
    transform: "translate(0.052 0.067)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M5.97,7.295V7.3l-.01-.01Z",
    transform: "translate(0.055 0.067)",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M8.265,10.037,1.827,13.751a1.169,1.169,0,0,1-.606.172A1.235,1.235,0,0,1,.01,12.9L5.652,7.645v-.01h.02Z",
    transform: "translate(0 0.07)",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M5.96,7.295l.01.01v-.01Z",
    transform: "translate(0.055 0.067)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M4.915,7v.01H4.9L0,11.578V2.485Z",
    transform: "translate(0 0.022)",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M8.276,3.891,5.662,6.333h-.01L0,1.145A1.105,1.105,0,0,1,.161.611,1.186,1.186,0,0,1,.9.045a1.2,1.2,0,0,1,.928.121Z",
    transform: "translate(0 -0.001)",
    fill: "#949494"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStoreIcon);
export default __webpack_public_path__ + "static/media/play-store-icon.d97be94e3fd5052eb08b374d333a2c08.svg";
export { ForwardRef as ReactComponent };